export default __webpack_public_path__ + "static/media/url-shorteningImg_4.1bb32548.webp";